import React from 'react';
import './UnsupportedBrowserMessage.css';

function UnsupportedBrowserMessage() {
  return (
    <div className="UnsupportedBrowserMessage">
      <h1>This browser is currently not supported.</h1>
    </div>
  );
}

export default UnsupportedBrowserMessage;



// WEBPACK FOOTER //
// ./src/components/UnsupportedBrowserMessage.js